import { Link } from 'react-router-dom';

interface BlogPost {
  id: string;
  title: string;
  summary: string;
  image: string;
  slug: string;
  date: string;
  category: string;
}

export default function BlogDirectory() {
  const blogPosts: BlogPost[] = [
    {
      id: '9',
      title: 'Roll Off Dumpsters: The Anatomy of a Roll Off and Everything Important to Know',
      summary: 'Discover everything about roll-off dumpsters in this comprehensive guide. Learn the anatomy of these industrial containers, understand sizing options from 10 to 40 yards, master loading techniques, and get expert tips for your El Paso project.',
      image: 'https://public.readdy.ai/ai/img_res/9690991090cae48ac26a38ccd3909ce6.jpg',
      slug: 'roll-off-dumpster-anatomy',
      date: 'January 21, 2025',
      category: 'Equipment Guide'
    },
    {
      id: '8',
      title: 'Adopt-a-Highway in El Paso: What It Is, How It Affects Our Community & How to Participate',
      summary: 'Learn everything about the Adopt-a-Highway program in El Paso, Texas. Discover how this volunteer initiative keeps our highways clean, its positive impact on our community, and step-by-step instructions for how your business or organization can participate in this rewarding program.',
      image: 'https://readdy.ai/api/search-image?query=Volunteers%20in%20bright%20orange%20safety%20vests%20picking%20up%20litter%20along%20scenic%20desert%20highway%20in%20El%20Paso%20Texas%2C%20Franklin%20Mountains%20in%20background%2C%20clear%20blue%20sky%2C%20community%20service%20team%20working%20together%2C%20professional%20highway%20cleanup%20scene%20with%20safety%20cones%20and%20trash%20bags&width=800&height=500&seq=adopthwy1&orientation=landscape',
      slug: 'adopt-a-highway-el-paso',
      date: 'January 20, 2025',
      category: 'Community Service'
    },
    {
      id: '7',
      title: 'Illegal Dumping in El Paso: Laws, Consequences, and How to Report It',
      summary: 'Protect our community by understanding illegal dumping laws in El Paso and Texas. Learn what constitutes illegal dumping, the severe penalties violators face, and how to report violations to keep our city clean.',
      image: 'https://readdy.ai/api/search-image?query=Illegal%20dumping%20site%20with%20scattered%20trash%20and%20debris%20in%20desert%20area%20near%20El%20Paso%20Texas%2C%20environmental%20damage%20visible%2C%20warning%20signs%20posted%2C%20law%20enforcement%20investigating%20scene%2C%20serious%20environmental%20crime%20documentation&width=800&height=500&seq=illegaldump1&orientation=landscape',
      slug: 'illegal-dumping-guide',
      date: 'January 8, 2025',
      category: 'Legal & Compliance'
    },
    {
      id: '1',
      title: 'The Ultimate Guide to Choosing the Right Dumpster Size for Your El Paso Project',
      summary: 'Selecting the perfect dumpster size can save you money and hassle. Learn how to calculate your waste volume, understand the differences between 10, 20, 30, and 40-yard dumpsters, and discover which size works best for residential cleanouts, construction projects, and commercial needs in El Paso.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20waste%20management%20consultant%20showing%20different%20dumpster%20sizes%20on%20tablet%20to%20homeowner%20in%20modern%20El%20Paso%20residential%20driveway%2C%20bright%20sunny%20day%2C%20clean%20organized%20presentation%20with%20measuring%20tape%20and%20waste%20samples%2C%20educational%20consultation%20scene&width=800&height=500&seq=blog1&orientation=landscape',
      slug: 'choosing-right-dumpster-size-el-paso',
      date: 'January 15, 2025',
      category: 'Dumpster Rentals'
    },
    {
      id: '2',
      title: 'Spring Cleaning in El Paso: How to Declutter Your Home Like a Pro',
      summary: 'Spring is the perfect time to refresh your El Paso home. Discover room-by-room decluttering strategies, learn what items can be donated versus disposed of, and find out how professional junk removal services can make your spring cleaning effortless while keeping El Paso beautiful and organized.',
      image: 'https://readdy.ai/api/search-image?query=Happy%20family%20organizing%20and%20decluttering%20bright%20sunny%20living%20room%20in%20El%20Paso%20home%2C%20boxes%20labeled%20donate%20and%20trash%2C%20professional%20junk%20removal%20team%20helping%20in%20background%2C%20spring%20cleaning%20atmosphere%20with%20open%20windows%20and%20natural%20light&width=800&height=500&seq=blog2&orientation=landscape',
      slug: 'spring-cleaning-declutter-home-el-paso',
      date: 'January 12, 2025',
      category: 'Junk Removal'
    },
    {
      id: '3',
      title: 'Construction Waste Management: Best Practices for El Paso Contractors',
      summary: 'Efficient construction waste management is crucial for project success and environmental responsibility. Learn about proper material separation, recycling opportunities in El Paso, roll-off dumpster scheduling, and how to comply with local regulations while keeping your construction site clean, safe, and productive.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20construction%20site%20in%20El%20Paso%20with%20organized%20waste%20management%20system%2C%20large%20roll-off%20dumpster%2C%20workers%20sorting%20materials%20into%20recycling%20bins%2C%20clean%20organized%20job%20site%20with%20safety%20equipment%2C%20blue%20sky%20background&width=800&height=500&seq=blog3&orientation=landscape',
      slug: 'construction-waste-management-el-paso',
      date: 'January 10, 2025',
      category: 'Commercial Services'
    },
    {
      id: '4',
      title: 'What Can and Cannot Go in Your Dumpster: El Paso Disposal Guidelines',
      summary: 'Understanding disposal restrictions protects the environment and prevents extra fees. Get a comprehensive list of acceptable and prohibited items for El Paso dumpsters, learn about hazardous waste alternatives, discover recycling options, and find out how to properly dispose of electronics, appliances, and special materials.',
      image: 'https://readdy.ai/api/search-image?query=Educational%20infographic%20style%20image%20showing%20acceptable%20and%20prohibited%20waste%20items%20for%20dumpster%20disposal%2C%20green%20checkmarks%20and%20red%20X%20marks%2C%20various%20household%20items%20and%20construction%20materials%20organized%20in%20categories%2C%20clean%20professional%20layout&width=800&height=500&seq=blog4&orientation=landscape',
      slug: 'dumpster-disposal-guidelines-el-paso',
      date: 'January 8, 2025',
      category: 'Guidelines'
    },
    {
      id: '5',
      title: 'Eco-Friendly Waste Disposal: How El Paso Residents Can Reduce Their Environmental Impact',
      summary: 'Every El Paso resident can contribute to a cleaner environment through smart waste management. Explore recycling programs, composting basics, donation opportunities, and sustainable disposal practices. Learn how choosing the right waste disposal service helps reduce landfill waste and supports El Paso\'s green initiatives.',
      image: 'https://readdy.ai/api/search-image?query=Diverse%20El%20Paso%20community%20members%20participating%20in%20recycling%20and%20eco-friendly%20waste%20sorting%20at%20neighborhood%20collection%20center%2C%20colorful%20recycling%20bins%2C%20solar%20panels%20visible%2C%20green%20plants%2C%20people%20smiling%20and%20working%20together%20for%20environmental%20sustainability&width=800&height=500&seq=blog5&orientation=landscape',
      slug: 'eco-friendly-waste-disposal-el-paso',
      date: 'January 5, 2025',
      category: 'Sustainability'
    },
    {
      id: '6',
      title: 'Landlord\'s Guide to Property Cleanouts and Eviction Services in El Paso',
      summary: 'Property cleanouts require efficiency and professionalism. Discover the legal considerations for El Paso landlords, learn how to handle abandoned belongings, understand pricing factors for eviction cleanouts, and find out how professional services can help you prepare properties quickly for new tenants while staying compliant.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20property%20manager%20with%20clipboard%20inspecting%20clean%20empty%20apartment%20after%20eviction%20cleanout%20service%20in%20El%20Paso%2C%20before%20and%20after%20comparison%20visible%2C%20organized%20efficient%20workspace%2C%20professional%20team%20in%20background%20loading%20truck&width=800&height=500&seq=blog6&orientation=landscape',
      slug: 'landlord-property-cleanout-guide-el-paso',
      date: 'January 3, 2025',
      category: 'Property Management'
    }
  ];

  return (
    <section className="py-16 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="text-5xl font-bold text-gray-900 mb-4">
            El Paso Trash Talk!
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Everything about trash that home owners and businesses need to know
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {blogPosts.map((post) => (
            <article key={post.id} className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition-shadow">
              <div className="relative h-48 overflow-hidden">
                <img 
                  src={post.image} 
                  alt={post.title}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute top-4 left-4">
                  <span className="bg-teal-600 text-white px-3 py-1 rounded-full text-sm font-semibold">
                    {post.category}
                  </span>
                </div>
              </div>
              <div className="p-6">
                <div className="text-sm text-gray-500 mb-2">{post.date}</div>
                <h3 className="text-xl font-bold text-gray-900 mb-3 line-clamp-2">
                  {post.title}
                </h3>
                <p className="text-gray-600 mb-4 line-clamp-3">
                  {post.summary}
                </p>
                <Link
                  to={`/trash-talk/${post.slug}`}
                  className="inline-flex items-center gap-2 text-teal-600 font-semibold hover:text-teal-700 transition-colors cursor-pointer"
                >
                  Read More
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
